import styled from "../../../client-utils/styled/index.js";
import keyframes from "../../../client-utils/styled/keyframes.util.js";
import shouldForwardProp from "../../../client-utils/styled/shouldForwardProp.util.js";
import { coreComponentName, SEARCH_WRAPPER_CLOSED_WIDTH } from "./SearchBar.consts.js";
import { DOUBLE } from "../../../constants/numbers.consts.js";
import Box from "../../../components/atoms/Box/index.js";
import TextField from "../../../components/atoms/TextField/index.js";
import IconButton from "../../../components/atoms/IconButton/index.js";
// import classes
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
const BORDER_RADIUS_MODIFIER = 1.2;
const BORDER_RADIUS_MODIFIER_MOBILE = 1.6;
export const Root = styled(Box, {
    name: coreComponentName,
    slot: "Root",
})();
export const MobileSearchIcon = styled(IconButton, {
    name: coreComponentName,
    slot: "MobileSearchIcon",
})(({ theme }) => ({
    [`${theme.breakpoints.up("expanded")}`]: {
        display: "none",
    },
}));
export const SearchWrapper = styled(Box, {
    name: coreComponentName,
    slot: "SearchWrapper",
    shouldForwardProp: shouldForwardProp("open", "expanded", "width"),
})(({ theme, open, expanded, width }) => {
    const borderRadius = Number(theme.shape.borderRadius) * BORDER_RADIUS_MODIFIER;
    const mobileBorderRadius = Number(theme.shape.borderRadius) * BORDER_RADIUS_MODIFIER_MOBILE;
    const borderColor = theme.vars.palette.outline.variant;
    const expand = keyframes `
    0% {
      width: 0;
      left: 50%;
    }
    100% {
      width: 100%;
      left: 0;
    }
  `;
    return {
        position: "relative",
        background: open ? theme.vars.palette.surface.containerHigh : "transparent",
        borderTopLeftRadius: `${borderRadius}px`,
        borderTopRightRadius: `${borderRadius}px`,
        borderBottomLeftRadius: expanded ? 0 : `${borderRadius}px`,
        borderBottomRightRadius: expanded ? 0 : `${borderRadius}px`,
        borderBottom: "thin solid transparent",
        overflow: "hidden",
        width: open ? width : SEARCH_WRAPPER_CLOSED_WIDTH,
        transition: `width 0.2s ${open ? "step-start" : "step-end"}, ${theme.transitions.create([
            "background",
            "border-bottom-left-radius",
            "border-bottom-right-radius",
            "border-top-right-radius",
            "border-top-left-radius",
            "border-bottom",
        ], {
            duration: theme.transitions.duration.shortest,
        })}`,
        "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            height: "1px",
            backgroundColor: borderColor,
            animation: expanded && open ? `${expand} 0.5s forwards` : "none",
        },
        [`${theme.breakpoints.down("expanded")}`]: {
            width: "100%",
            paddingLeft: theme.spacing(DOUBLE),
            paddingRight: theme.spacing(DOUBLE),
            borderRadius: mobileBorderRadius,
            borderBottomLeftRadius: expanded ? 0 : `${mobileBorderRadius}px`,
            borderBottomRightRadius: expanded ? 0 : `${mobileBorderRadius}px`,
        },
    };
});
export const SearchField = styled(TextField, {
    name: coreComponentName,
    slot: "Search",
})({
    borderRadius: 0,
    [`.${outlinedInputClasses.root}`]: {
        paddingRight: 0,
    },
    "& fieldset": {
        border: "none",
        borderRadius: 0,
    },
});
export const PreviousQuery = styled(Box, {
    name: coreComponentName,
    slot: "PreviousQuery",
})(({ theme }) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(DOUBLE),
}));
